module.exports = __webpack_public_path__ + "static/media/who-logo-white.dd83d138.svg";